import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { WizardSteps } from "./WizardSteps";
import { Nextsteps } from "./NextStep";
import warning from "../../assets/icons/warning.png";

export const Six = (props) => {
  const validate = () => {
    if (window.confirm("Are you sure you want to go back?")) {
      // eslint-disable-line
      props.previousStep();
    }
  };
  const [state, updateState] = useState({
    ratePerHour: "",
    serviceFee: "",
    onFocusRatePerHour: "",
  });

  // step6: {
  //   ratePerHour: 30,
  // },
  useEffect(() => {
    let { ratePerHour, serviceFee } = state;
    let TutorInfoObj = props?.TutorInfoObj ? props?.TutorInfoObj : {};
    ratePerHour = TutorInfoObj?.step6?.ratePerHour;
    serviceFee = TutorInfoObj?.step6?.serviceFee;

    if (!ratePerHour) {
      ratePerHour = "";
    }

    if (!serviceFee) {
      serviceFee = "";
    }

    updateState((state) => ({
      ...state,
      ratePerHour,
      serviceFee,
    }));
    if (props.funcStatus === "loading..." && props.currentStep === 6) {
      submitStep6Info(true);
    }
  }, [props]);

  const submitStep6Info = (isCallApi) => {
    const { ratePerHour, serviceFee } = state;
    const { TutorInfoObj } = props;

    let step6 = {
      ratePerHour: Number(ratePerHour),
      serviceFee: Number(serviceFee),
    };
    TutorInfoObj.step6 = step6;
    props.AddTutorInfo(TutorInfoObj);
    return isCallApi ? props.AddTutorInfoStepBeforeCallApi("done") : null;
    // if (ratePerHour) {
    //   TutorInfoObj.step6 = step6;
    //   props.AddTutorInfo(TutorInfoObj);
    //   return true;
    // } else {
    //   return false;
    // }
  };

  const { serviceFee, ratePerHour, onFocusRatePerHour } = state;
  const { iscompletedForm, validationError } = props;

  let color, borderColor, backgroundColor;

  if (onFocusRatePerHour) {
    color = "";
    borderColor = "#2cb46d";
    backgroundColor = "";
  } else if (!ratePerHour && validationError?.data?.ratePerHour) {
    color = "#fa4a4a";
    borderColor = "#fa4a4a";
    backgroundColor = "#fff1f1";
  } else {
    color = "";
    borderColor = "";
    backgroundColor = "";
  }

  let warningError = (
    <img
      src={warning}
      alt="warning"
      width="14px"
      height="14px"
      style={{ marginRight: "6px" }}
    />
  );

  return (
    <Row className="m-0">
      <WizardSteps step={6} {...props} previousStep={validate} />
      <Col lg={12} md={12} sm={12} xs={12}>
        <div className="container">
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="subject-mode date-div"
            >
              <p className="step-title">Set your price per hour</p>
              <h1 className="step-subtitle">
                The price your sessions is entirely up to you. This amount will
                appear on your profile and it is the hourly rates parents and
                students will pay for our session. We charge tutors a 20% fee
                and it is calculated based on the per price per hour. This fee
                is automatically deducted from the tutor's payout.
              </h1>
              <div className="row">
                <div className="col-lg-6">
                  <label className="date-txt">Hourly rate</label>
                  <div
                    tabIndex="-1"
                    className="comp_input"
                    onBlur={(e) =>
                      updateState({ ...state, onFocusRatePerHour: false })
                    }
                    onFocus={(e) =>
                      updateState({ ...state, onFocusRatePerHour: true })
                    }
                    style={{
                      color: color,
                      borderColor: borderColor,
                      backgroundColor: backgroundColor,
                    }}
                  >
                    <span
                      className="GBP"
                      onBlur={(e) =>
                        updateState({ ...state, onFocusRatePerHour: false })
                      }
                      onFocus={(e) =>
                        updateState({ ...state, onFocusRatePerHour: true })
                      }
                      style={{
                        color: onFocusRatePerHour ? "#2cb46d" : color,
                        borderColor: borderColor,
                        backgroundColor: backgroundColor,
                      }}
                    >
                      GBP
                    </span>
                    <input
                      type="number"
                      name="Your rate"
                      placeholder="0.00"
                      value={ratePerHour}
                      className="form-control"
                      disabled={!iscompletedForm ? false : true}
                      onBlur={(e) =>
                        updateState({ ...state, onFocusRatePerHour: false })
                      }
                      onFocus={(e) =>
                        updateState({ ...state, onFocusRatePerHour: true })
                      }
                      style={{
                        color: color,
                        borderColor: borderColor,
                        backgroundColor: backgroundColor,
                      }}
                      onChange={(e) =>
                        updateState({
                          ...state,
                          ratePerHour: e.target.value,
                          serviceFee:
                            e.target.value !== ""
                              ? (e.target.value * 20) / 100
                              : "",
                        })
                      }
                    />
                  </div>
                  <div className="error">
                    {!ratePerHour
                      ? validationError?.data?.ratePerHour
                        ? warningError
                        : ""
                      : ""}
                    {!ratePerHour
                      ? validationError?.data?.ratePerHour
                        ? validationError?.data?.ratePerHour
                        : ""
                      : ""}
                  </div>
                </div>
                <div className="col-lg-6">
                  <label className="date-txt">Service fee </label>
                  <div
                    className="comp_input"
                    style={{
                      color: !ratePerHour
                        ? validationError?.data?.ratePerHour
                          ? "#fa4a4a"
                          : ""
                        : "",
                      borderColor: !ratePerHour
                        ? validationError?.data?.ratePerHour
                          ? "#fa4a4a"
                          : ""
                        : "",
                      backgroundColor: !ratePerHour
                        ? validationError?.data?.ratePerHour
                          ? "#fff1f1"
                          : ""
                        : "",
                    }}
                  >
                    <span
                      className="GBP"
                      style={{
                        color: !ratePerHour
                          ? validationError?.data?.ratePerHour
                            ? "#fa4a4a"
                            : ""
                          : "",
                        borderColor: !ratePerHour
                          ? validationError?.data?.ratePerHour
                            ? "#fa4a4a"
                            : ""
                          : "",
                        backgroundColor: !ratePerHour
                          ? validationError?.data?.ratePerHour
                            ? "#fff1f1"
                            : ""
                          : "",
                      }}
                    >
                      GBP
                    </span>
                    <input
                      disabled
                      type="number"
                      name="serviceFee"
                      placeholder="0.00"
                      value={serviceFee}
                      className="form-control"
                      style={{
                        color: !ratePerHour
                          ? validationError?.data?.ratePerHour
                            ? "#fa4a4a"
                            : ""
                          : "",
                        borderColor: !ratePerHour
                          ? validationError?.data?.ratePerHour
                            ? "#fa4a4a"
                            : ""
                          : "",
                        backgroundColor: !ratePerHour
                          ? validationError?.data?.ratePerHour
                            ? "#fff1f1"
                            : ""
                          : "",
                      }}
                    />
                  </div>
                  <div className="error">
                    {!ratePerHour
                      ? validationError?.data?.ratePerHour
                        ? warningError
                        : ""
                      : ""}
                    {!ratePerHour
                      ? validationError?.data?.ratePerHour
                        ? "Service Fee missing"
                        : ""
                      : ""}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Nextsteps step={6} {...props} submitStepInRedux={submitStep6Info} />
        </div>
      </Col>
    </Row>
  );
};
